import { CoreStylingModel } from '../core/core-styling.model';
import { FabButtonStylingModel } from '../fab/fab-button-styling.model';
export class FabStylingModel extends CoreStylingModel {
/**
 * FabButtonStylingModel for trigger icon
 */
trigger?: FabButtonStylingModel;
/**
 * Styling for fab action items container
 */
itemsContainer?: {
    /**
     * Classes for itemsContainer section
     */
    class?: string;
    /**
     * Dynamic classes for itemsContainer section
     */
    dynamicClass?: any;
    /**
     * FabButtonStylingModel for each mini fab action item
     */
    item?: FabButtonStylingModel;
  };
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function FabStylingModel_tsickle_Closure_declarations() {
/**
 * FabButtonStylingModel for trigger icon
 * @type {?}
 */
FabStylingModel.prototype.trigger;
/**
 * Styling for fab action items container
 * @type {?}
 */
FabStylingModel.prototype.itemsContainer;
}

